import type { FavoriteHotels } from '@/interfaces';

const defaultResponse: FavoriteHotels = {
    folders: [],
    hotelIds: [],
};

//this hook is disabled until we know the state of new hotel ids
export const useFavoriteHotelsAPI = (): FavoriteHotels => defaultResponse;
// {
// const { userId } = useUserId();
//
// const { data, error } = useFetch<FavoriteHotels>({
//     isEnabled: Boolean(userId),
//     url: `${publicRuntimeConfig.hotelApiUrl}/favorites`,
// });
//
// if (error || !data) {
//     return defaultResponse;
// }
//
// return data;
// };
